import axiosInstance from "../axiosinstance";
import { normalizeDateTime } from "../utils/attendanceHeatmap";

/** @typedef {import("../types/attendanceHeatmap").HeatmapQuery} HeatmapQuery */
/** @typedef {import("../types/attendanceHeatmap").HeatmapResponse} HeatmapResponse */

/**
 * Fetch attendance heatmap points for an explicitly selected date range.
 *
 * @param {string} projectId
 * @param {HeatmapQuery} query
 * @param {AbortSignal} [signal]
 * @returns {Promise<HeatmapResponse>}
 */
export async function getAttendanceHeatmap(projectId, query, signal) {
  const params = new URLSearchParams({
    start_date: normalizeDateTime(query.startDate),
    end_date: normalizeDateTime(query.endDate),
    timezone_mode: query.timezoneMode,
    viewer_timezone: query.viewerTimezone,
  });
  if (query.supervisorId) params.set("supervisor_id", query.supervisorId);
  if (query.designation) params.set("designation", query.designation);

  const response = await axiosInstance.get(
    `/api/nfc/heatmap/${encodeURIComponent(projectId)}`,
    { params, signal },
  );

  return response.data;
}
